export { default } from "./AddProductFormGeneral"
